import { render, staticRenderFns } from "./PreChatFields.vue?vue&type=template&id=a33c38ae&scoped=true&"
import script from "./PreChatFields.vue?vue&type=script&lang=js&"
export * from "./PreChatFields.vue?vue&type=script&lang=js&"
import style0 from "./PreChatFields.vue?vue&type=style&index=0&id=a33c38ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c38ae",
  null
  
)

export default component.exports